<template>
  <body>
    <div
      id="main-wrapper"
      data-layout="vertical"
      data-navbarbg="skin5"
      data-sidebartype="full"
      data-sidebar-position="absolute"
      data-header-position="absolute"
      data-boxed-layout="full"
    >
      <Header></Header>

      <Sidebar></Sidebar>

      <div class="dashboard-wrapper page-wrapper">
        <div class="page-breadcrumb">
          <div class="row align-items-center">
            <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
              <h4 class="page-title">Create Inspired</h4>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12 col-xlg-9 col-md-12">
              <form
                class="form-horizontal form-material"
                v-on:submit.prevent="submit"
              >
                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Title</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.title.$model"
                          :class="{'is-invalid': validationStatus($v.title)}"
                          class="form-control form-control-lg"
                        />
                        <div v-if="!$v.title.required" class="invalid-feedback">
                          The title field is required.
                        </div>
                      </div>
                    </div>
					

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Short Description</label>
                      <div class="col-md-12 border-bottom p-0">
                        <textarea
                          v-model.trim="$v.short_description.$model"
                          :class="{'is-invalid': validationStatus($v.short_description)}"
                          class="form-control form-control-lg"
                          rows="2"
                        ></textarea>
                        <div
                          v-if="!$v.short_description.required"
                          class="invalid-feedback"
                        >
                          The short description field is required.
                        </div>
                      </div>
                    </div>
                    <!-- button text --->
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Button Text</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.btext.$model"
                          :class="{'is-invalid': validationStatus($v.btext)}"
                          class="form-control form-control-lg"
                        />
                        <div v-if="!$v.btext.required" class="invalid-feedback">
                          The Button text field is required.
                        </div>
                      </div>
                    </div>
					

                    <!-- End of the button text --->
                      <div class="form-group mb-4">
                    <label class="col-md-12 p-0">Image</label>
                    <div class="col-md-12 border-bottom p-0">
                      <div class="formcta_wrapper">
                        <div>
                          <input required
                            type="file"
                            @change="previewImage"
                            accept="image/*"
                          />
                        </div>
                        <div>
                          <p>
                            Progress: {{uploadValue.toFixed()+"%"}}
                            <progress
                              id="progress"
                              :value="uploadValue"
                              max="100"
                            ></progress>
                          </p>
                        </div>
                        <div v-if="imageData!=null">
                          <img class="preview" :src="picture" />

                          <button @click="onUpload">Upload</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  </div>
                </div>

                <div class="card profile-card">
                  <div class="card-body">
                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Title</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.meta_title.$model"
                          :class="{'is-invalid': validationStatus($v.meta_title)}"
                          class="form-control form-control-lg"
                        />
                        <div
                          v-if="!$v.meta_title.required"
                          class="invalid-feedback"
                        >
                          The meta title field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Description</label>
                      <div class="col-md-12 border-bottom p-0">
                        <textarea
                          v-model.trim="$v.meta_description.$model"
                          :class="{'is-invalid': validationStatus($v.meta_description)}"
                          class="form-control form-control-lg"
                          rows="5"
                        ></textarea>
                        <div
                          v-if="!$v.meta_description.required"
                          class="invalid-feedback"
                        >
                          The meta description field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <label class="col-md-12 p-0">Meta Keywords</label>
                      <div class="col-md-12 border-bottom p-0">
                        <input
                          type="text"
                          v-model.trim="$v.meta_keywords.$model"
                          :class="{'is-invalid': validationStatus($v.meta_keywords)}"
                          class="form-control form-control-lg"
                        />
                        <div
                          v-if="!$v.meta_keywords.required"
                          class="invalid-feedback"
                        >
                          The meta keywords field is required.
                        </div>
                      </div>
                    </div>

                    <div class="form-group mb-4">
                      <div class="col-sm-12 pl-0 mt-10">
                        <input
                          type="submit"
                          class="btn btn-primary"
                          value="Submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  </body>
</template>

<script>

import Header from './../admin-header';
import Footer from './../admin-footer';
import Sidebar from './../admin-sidebar';
import firebase from 'firebase';

import { required } from 'vuelidate/lib/validators'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { db } from '../../main'


Vue.use(VueAxios,axios)

export default {
    name: 'Create',
    components:{
        'Header':Header,
        'Sidebar':Sidebar,
        'Footer':Footer,
    },
    data: function() {
        return {
            btext:'',
            title:'',
            short_description:'',
            imageData: null,
		picture: null,
			uploadValue: 0,
            meta_title: '',
            meta_description: '',
            meta_keywords: '',
         
        }
    },
    created: function(){
    },

    validations: {
       
        title: {required},
        btext:{required},
        short_description: {required},
        image: {},
        meta_title: {},
        meta_description: {},
        meta_keywords: {}
    },

    methods: {
       
	previewImage(event) {
				this.uploadValue = 0;
				this.picture = null;
				this.imageData = event.target.files[0];
				console.log(this.imageData);
			},
			onUpload(event) {
         event.preventDefault();
				this.picture = null;
      // eslint-disable-next-line no-unused-vars
      let imagearray = this.imageData.name.split('.');
         // eslint-disable-next-line no-unused-vars
         var imagename = imagearray[0];
         // eslint-disable-next-line no-unused-vars
         var imageextension = imagearray[1];
         function makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * 
        charactersLength));
          }
          return result;
        }
				const storageRef = firebase.storage().ref(imagename+makeid(5)+"."+imageextension).put(this.imageData);
				storageRef.on('state_changed', snapshot => {
					this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				}, error => {
					console.log(error.message)
				}, () => {
					this.uploadValue = 100;
					storageRef.snapshot.ref.getDownloadURL().then((url) => {
						this.picture = url;
           
          //alert(this.picture);
					});
				});
			},

       

        validationStatus: function(validation) {
            return typeof validation != "undefined" ? validation.$error : false;
        },

        submit: function() {
      //alert(this.picture);
            this.$v.$touch();
            if (this.$v.$pendding || this.$v.$error) return;
            var  date = new Date().toLocaleString();
            db.collection("inspired")
            .add({
                title: this.title,
                btext:this.btext,
                image: this.picture,
                short_description: this.short_description,
                meta_title: this.meta_title,
                meta_description: this.meta_description,
                meta_keywords: this.meta_keywords,
                created: date,
                modified: date,
            })
            .then(() => {
                console.log("Added Successfully!");
                this.$toasted.success('Success, Added Successfully!', {
                   icon : 'check',
                    //icon : 'error_outline'
                })
                this.$router.push('/inspired/index');
            })
            .catch((error) => {
                console.error("Error writing document: ", error);
            });

        }
    }
}
</script>
